import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AdminGuardStateService {
  readonly adminCheck: WritableSignal<boolean> = signal<boolean>(false);
  readonly authorized: WritableSignal<boolean> = signal<boolean>(false);
}
